import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import ProduttivoMuiTheme from '../components/shared/themes/ProduttivoTheme';
import InvoiceShowContainer from './invoices/show/InvoiceShowContainer';

const invoicesShowErb = document.getElementById('invoices_show-container');

if (invoicesShowErb != null) {
  const invoiceId = invoicesShowErb.dataset.invoiceId;

  const root = createRoot(invoicesShowErb);
  root.render(
    <ThemeProvider theme={ProduttivoMuiTheme}>
      <InvoiceShowContainer invoiceId={invoiceId} />
    </ThemeProvider>
  );
}